(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class StickyTopHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.topheader = document.querySelector('.announcement-bar-section');
      this.topheaderIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.topheaderBounds = {};

      this.setTopHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setTopHeaderHeight.bind(this));

      if (this.topheaderIsAlwaysSticky) {
        this.topheader.classList.add('shopify-section-top-bar-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }
    
    setTopHeaderHeight() {
      document.documentElement.style.setProperty('--top-bar-height', `${this.topheader.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.topheaderBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.topheader);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.topheaderBounds.bottom) {
        this.topheader.classList.add('scrolled-past-top-bar');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.topheaderBounds.bottom) {
        this.topheader.classList.add('scrolled-past-top-bar');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.topheaderBounds.top) {
        this.topheader.classList.remove('scrolled-past-top-bar');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.topheaderIsAlwaysSticky) return;
      this.topheader.classList.add('shopify-section-top-bar-hidden', 'shopify-section-top-bar-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.topheaderIsAlwaysSticky) return;
      this.topheader.classList.add('shopify-section-top-bar-sticky', 'animate');
      this.topheader.classList.remove('shopify-section-top-bar-hidden');
    }

    reset() {
      if (this.topheaderIsAlwaysSticky) return;
      this.topheader.classList.remove('shopify-section-top-bar-hidden', 'shopify-section-top-bar-sticky', 'animate');
    }
  }

  customElements.define('sticky-top-bar', StickyTopHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }
    
    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lds-logo-slider-section"] && !Shopify.designMode) return;
  try {
    
// Vérifier si nous sommes sur la page d'accueil (index)
if (document.body.classList.contains('index')) {
    // Sélectionner l'élément .section_slideshow
    const slideshowSection = document.querySelector('.section_slideshow');

    // Vérifier si la section .lds-logo-slider-section suit directement .section_slideshow
    if (slideshowSection && slideshowSection.nextElementSibling && slideshowSection.nextElementSibling.classList.contains('lds-logo-slider-section')) {
        // Sélectionner l'élément .lds-logo-slider-section
        const logoSliderSection = slideshowSection.nextElementSibling;

        // Fonction pour définir la hauteur de la section .lds-logo-slider-section
        function setLogoSliderSectionHeight() {
            document.documentElement.style.setProperty('--logo-slider-height', `${logoSliderSection.offsetHeight}px`);
        }

        // Appeler la fonction pour mettre à jour la hauteur au chargement de la page
        window.addEventListener('load', () => {
            setLogoSliderSectionHeight();
        });

        // Optionnel : Si la taille de la fenêtre change (pour le responsive), mettre à jour la hauteur
        window.addEventListener('resize', () => {
            setLogoSliderSectionHeight();
        });
    }
}

  } catch(e) { console.error(e); }
})();
})();
